import { useToggle } from "../../../hooks/useToggle.js";
import { LabeledInputControlsButton } from "../../shared/LabeledInput/LabeledInputControlsButton.js";
import { useOnClickOutside } from "../../../hooks/useOnClickOutside.js";
import { LocationNames } from "./LocationNames.js";
import { SelectLocation } from "./SelectLocation.js";
import { SelectLocationFromLocationAndGroupIds } from "./SelectLocationFromLocationAndGroupIds.js";
import { useRef } from "react";
import { Icon } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { MdEdit } from "react-icons/md";
//#region src/modules/Locations/shared/LabeledSelectLocation.tsx
function LabeledSelectLocation({ locationAndGroupIds, multi, onComplete, value }) {
	const [editMode, toggleEditMode] = useToggle(false);
	const inputRef = useRef(null);
	useOnClickOutside(inputRef, toggleEditMode);
	if (!editMode && !value.length) return /* @__PURE__ */ jsxs("div", {
		onClick: toggleEditMode,
		className: "p-xxs bg-surface-strong hover:bg-neutral-faded group flex h-10 min-h-10 w-full cursor-pointer justify-center rounded transition-colors",
		children: [/* @__PURE__ */ jsxs("div", {
			className: "flex w-full flex-col content-center space-x-0.5",
			children: [/* @__PURE__ */ jsx("div", {
				className: "text-neutral min-w-fit content-center text-xs font-bold",
				children: "Locations"
			}), /* @__PURE__ */ jsx("div", {
				className: "text-neutral-faded flex text-sm",
				children: "None Selected"
			})]
		}), /* @__PURE__ */ jsx("div", {
			className: "inline-flex items-center justify-center",
			children: /* @__PURE__ */ jsx(Icon, {
				className: "ml-xs text-color-neutral-faded group-hover:text-color-semantic opacity-50 transition-colors",
				Icon: MdEdit,
				size: "xs"
			})
		})]
	});
	if (editMode) return /* @__PURE__ */ jsxs("div", {
		className: "gap-x-xs inline-flex h-10 w-full items-center",
		children: [/* @__PURE__ */ jsx("div", {
			className: "w-full",
			ref: inputRef,
			children: locationAndGroupIds ? /* @__PURE__ */ jsx(SelectLocationFromLocationAndGroupIds, {
				menuIsOpen: true,
				multi,
				placeholder: "Locations",
				value,
				locationAndGroupIds,
				combineSelected: true,
				onBlur: toggleEditMode,
				onChangeValue: onComplete
			}) : /* @__PURE__ */ jsx(SelectLocation, {
				menuIsOpen: true,
				multi,
				placeholder: "Locations",
				value,
				combineSelected: true,
				onBlur: toggleEditMode,
				onChangeValue: onComplete
			})
		}), /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(LabeledInputControlsButton, { onComplete: toggleEditMode }) })]
	});
	return /* @__PURE__ */ jsxs("div", {
		onClick: toggleEditMode,
		className: "p-xxs bg-surface-strong hover:bg-neutral-faded group flex h-10 min-h-10 w-full cursor-pointer justify-center rounded transition-colors",
		children: [/* @__PURE__ */ jsxs("div", {
			className: "flex w-full flex-col content-center space-x-0.5",
			children: [/* @__PURE__ */ jsx("div", {
				className: "text-neutral min-w-fit content-center text-xs font-bold",
				children: "Locations"
			}), /* @__PURE__ */ jsx("div", {
				className: "flex text-sm",
				children: /* @__PURE__ */ jsx(LocationNames, {
					locationIds: value,
					listAll: false
				})
			})]
		}), /* @__PURE__ */ jsx("div", {
			className: "inline-flex items-center justify-center",
			children: /* @__PURE__ */ jsx(Icon, {
				className: "ml-xs text-color-neutral-faded group-hover:text-color-semantic opacity-50 transition-colors",
				Icon: MdEdit,
				size: "xs"
			})
		})]
	});
}
//#endregion
export { LabeledSelectLocation };

//# sourceMappingURL=LabeledSelectLocation.js.map